export default __webpack_public_path__ + "static/media/mobile_benefit_bg.171e905d.jpg";